import { render, staticRenderFns } from "./dataTemplate.vue?vue&type=template&id=39720f80&scoped=true&"
import script from "./dataTemplate.vue?vue&type=script&lang=js&"
export * from "./dataTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dataTemplate.vue?vue&type=style&index=0&id=39720f80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39720f80",
  null
  
)

export default component.exports